import Label from 'components/Label';
import { ReactComponent as Mail } from 'assets/icons/socials/Mail.svg';
import { Link } from 'react-router-dom';
import useMediaQuery from 'hooks/useMediaQuery';

const FAQSideText = ({ tag, sideTitle, desc, button_link, title, button_text, }) => {
    const isMobile = useMediaQuery('max-width: 640px');

    return (
        <div className="faq-sidetext">
            <Label text={tag} />
            <h2>{sideTitle}</h2>
            {!isMobile && (
                <div className="faq-sidetext__stills">
                    <div className="body2">{title}</div>
                    <Link to={button_link} aria-label='Contact with us' className="button-text">
                        <Mail /> {button_text}
                    </Link>
                </div>
            )}
        </div>
    );
};

export default FAQSideText;
